import imageCompression from 'browser-image-compression';

import apiClient from "./ApiService";

const uploadFile = (file, url) => fetch(url, {
        method: "PUT",
        body: file,
    })

const getSignedUrl = (key) => apiClient.get(`/file?key=${encodeURIComponent(key)}`)

const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    }
    try {
        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    } catch (error) {
        return file;
    }
}

const uploadRequestAttachment = (requestId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/timesheet/requests/${requestId}/attachment`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

const uploadExpenseReportAttachment = (expenseReportId, file, kind = 'receipt') => {
  const formData = new FormData();
  formData.append('kind', kind);
  formData.append('file', file);
  return apiClient.post(`/employee/expense-report/${expenseReportId}/attachment`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

/** Estrae data, totale, esercente e località dallo scontrino tramite l'API Bedrock. */
const parseExpenseReportReceipt = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post('/employee/expense-report/parse-receipt', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 45000,
  });
}

const uploadTimesheetAttachment = (date, file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('date', date);
  return apiClient.post(`/timesheet/justify/attachment`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

const uploadProfilePicture = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/employee/profile-picture`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

const FileService = {
    uploadFile,
    getSignedUrl,
    compressImage,
    uploadRequestAttachment,
    uploadExpenseReportAttachment,
    parseExpenseReportReceipt,
    uploadTimesheetAttachment,
    uploadProfilePicture,
};

export default FileService;
